import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AngularFireList } from '@angular/fire/database';
import { MatTableDataSource } from '@angular/material';
import { Stop } from '../../../@core/models/live-route';
import { ParcelHistoryDialogComponent } from '../../../@theme/components/parcel-history-dialog/parcel-history-dialog.component';
import { DashboardBase } from './dashboard.base';
import { ElementQueries } from 'css-element-queries';
import { NewTpslRouteModal } from '../../../@theme/components/new-tpslRoute-modal/new-tpslRoute-modal.component';

@Component({
  selector: 'ngx-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'void',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class DashboardComponent extends DashboardBase implements OnInit, AfterViewInit {
  public childdisplayedColumns: string[] = [
    'IsSelected',
    'Address.Postal_Code',
    'CustomerName',
    'Address.Address1'
  ];
  public childdisplayedColumnsheader: string[] = [
    'IsSelected',
    'ConsolID',
    'Address.Postal_Code',
    'CustomerName',
    'Address.Address1'
  ];
  public itemsRef: AngularFireList<any>;

  ngAfterViewInit() {
    ElementQueries.listen();
    ElementQueries.init();
  }

  ngOnInit() {
    this._parcelhistoryService.language = this.authenticationService.currentUserValue.language;
    this._stopService.dataSource = new MatTableDataSource<Stop>(null);
    this.OpenNewTpslRouteModal();
    // this.IsAfter7pm();
  }

  public ShouldEnableTrace(): boolean {
    if (this._optimizationService.CurrentDataRoot.Mode) {
      return (
        this._optimizationService.CurrentDataRoot.Mode ===
        'Automatique[Routiffic]'
      );
    }
  }

  public GetParcelHistories(ParcelID: number) {
    this._parcelhistoryService.initialiseParcel(ParcelID);
    const dialogRef = this.dialog.open(ParcelHistoryDialogComponent, {
      height: '700px',
      width: '1400px',
      data: { parcelId: ParcelID }
    });
  }

  public setSelectedSectorId(sectorId: number) {
    this._sectorService.SectorID = sectorId;
    this._sectorService.initialiseSector();
  }

  /**
   * Creates a dialog to add an exception and refresh the stop list if it is successful
   */

  public IsAfter7pm() {
    const now = new Date();
    const nowTime = new Date(
      now.getMonth() +
      1 +
      '/' +
      now.getDate() +
      '/' +
      now.getFullYear() +
      ' ' +
      now.getHours() +
      ':' +
      now.getMinutes()
    );
    const userTime = new Date(
      now.getMonth() +
      1 +
      '/' +
      now.getDate() +
      '/' +
      now.getFullYear() +
      ' ' +
      '19:00'
    );
    if (nowTime.getTime() > userTime.getTime()) {
      const newdate = new Date();
      newdate.setDate(newdate.getDate() + 1);
      this._stopService.RouteDate = newdate;
    }
  }

  OpenNewTpslRouteModal() {
    //const dialogRef = this.dialog.open(NewTpslRouteModal);
  }

}
